var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('menu-comment-button',{attrs:{"icon":"double-quotes","title":"Block Quote","command":_vm.runCommand,"is-active":_vm.isActive}})
}
var staticRenderFns = []

export { render, staticRenderFns }